module.exports = __webpack_public_path__ + "img/yuni_cards.6ecd63ef.webp";